import appGlobalScript from '/home/pierre/WARP10src/discovery/discovery-widgets/src/discovery.ts';
export const globalScripts = appGlobalScript;
